export default function formatHardwareLabel(name) {
    const versionParts = []
    let label = name
        .toLowerCase()
        .replace(/(\d+)-(\d+)/g, (_, major, minor) => {
            versionParts.push(`${major}.${minor}`)
            return `{{V${versionParts.length - 1}}}`
        })
        .replace(/[-_]+/g, ' ')

    label = label.replace(/io([a-z])/g, (match, p1) => 'io' + p1.toUpperCase())
    label = label.replace(/ [a-z]/g, (match) => match.toUpperCase())
    label = label.replace(/\bLte\b/g, 'LTE')
    label = label.replace(/\bLora\b/gi, 'LoRa')
    label = label.replace(/\{\{V(\d+)\}\}/g, (_, index) => versionParts[index])
    return label.trim()
}
